exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-overview-box{flex:1;width:100%;overflow:auto;height:0;display:flex;flex-flow:column}.overview-box-content{padding:10px;flex:1;display:flex;flex-flow:column}.tag-row{display:flex;flex-flow:row;width:100%}.option-overview-box .label{display:flex;height:30px;align-items:center;justify-content:flex-start;color:#c2c2c2;font-size:12px;width:70px;flex-shrink:0}.tag-row input{background:rgba(0,0,0,.15);color:#d3d3d3;outline:transparent;border:0;padding:3px;width:100px}.class-area{display:flex;flex-flow:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-252ef5f6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shell/components/options/OptionOverviewBox.vue
// module id = 328
// module chunks = 0